import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './FieldPartnersWaitlist.css';

const FieldPartnersWaitlist = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        serviceArea: '',
        website: '',
        socials: '',
    });
    const [isSubmitted, setIsSubmitted] = useState(false);

    // Scroll to top when page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.target;
        const data = new FormData(form);

        // Submit to Web3Forms
        const response = await fetch('https://api.web3forms.com/submit', {
            method: 'POST',
            body: data,
        });

        const result = await response.json();

        if (result.success) {
            setIsSubmitted(true);
        } else {
            console.error('Form submission error:', result);
            alert('There was an error submitting your form. Please try again or email us directly.');
        }
    };

    if (isSubmitted) {
        return (
            <div className="waitlist-page">
                <div className="waitlist-container">
                    <div className="waitlist-success">
                        <h2>You're on the list!</h2>
                        <p>
                            Thank you for your interest in becoming a BAi Field Partner.
                            We'll be in touch soon as we expand into your market.
                        </p>
                        <button className="btn btn-primary" onClick={() => navigate('/')}>
                            Return to Homepage
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="waitlist-page">
            <div className="waitlist-container">

                <div className="waitlist-header">
                    <span className="label">Field Partner Program</span>
                    <h1>Join the Waitlist</h1>
                    <p>
                        We're building a nationwide network of skilled installation partners.
                        Join our waitlist to be notified when we're ready to partner in your market.
                    </p>
                </div>

                <form className="waitlist-form" onSubmit={handleSubmit}>
                    <input type="hidden" name="access_key" value="c917a05a-3d9c-4b80-bdbb-ac2c2c4b0a45" />
                    <input type="hidden" name="subject" value="New Field Partner Waitlist Signup - BAi Systems" />
                    <input type="hidden" name="from_name" value="BAi Systems Field Partner Waitlist" />

                    <div className="form-group">
                        <label htmlFor="name">Your Name *</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="John Smith"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email Address *</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="john@yourcompany.com"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="phone">Phone Number *</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            placeholder="(555) 123-4567"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="company">Company Name *</label>
                        <input
                            type="text"
                            id="company"
                            name="company"
                            value={formData.company}
                            onChange={handleChange}
                            required
                            placeholder="Your installation company"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="serviceArea">Geographic Service Area *</label>
                        <textarea
                            id="serviceArea"
                            name="serviceArea"
                            value={formData.serviceArea}
                            onChange={handleChange}
                            required
                            placeholder="e.g., Greater Denver Metro, Front Range Colorado, or nationwide"
                            rows="2"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="website">Website <span className="optional">(optional)</span></label>
                        <input
                            type="url"
                            id="website"
                            name="website"
                            value={formData.website}
                            onChange={handleChange}
                            placeholder="https://yourcompany.com"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="socials">Social Media <span className="optional">(optional)</span></label>
                        <input
                            type="text"
                            id="socials"
                            name="socials"
                            value={formData.socials}
                            onChange={handleChange}
                            placeholder="Instagram, LinkedIn, or other social links"
                        />
                    </div>

                    <button type="submit" className="btn btn-primary btn-full">
                        Join the Waitlist
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3.33 8h9.34M8 3.33L12.67 8 8 12.67" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </form>

                <div className="waitlist-footer">
                    <p>
                        Questions? Email us at{' '}
                        <a href="mailto:partners@bai-systems.com">partners@bai-systems.com</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FieldPartnersWaitlist;
